export default {
  styleOverrides: {
    root: {
      fontSize: 14,
      fontFamily: 'Source Han Sans CN, Arial, sans-serif',
    },
  },
};
